// extracted by mini-css-extract-plugin
export var closeButton = "_l5-1";
export var closeX = "_l5-3";
export var container = "_l5-0";
export var image = "_l5-2";